<div class="specs-container">
    <h2>Especificaciones</h2>
    @for (item of specs(); track $index) {
        <h3>{{item.title}}</h3>
        <table>
            @for (spec of item.specs; track $index) {
                <tr>
                    <td class="key">
                        {{spec.key}}
                    </td>
                    <td class="value">
                        <div class="value-container">
                            
                            <div class="value-main" [innerHTML]="spec.value" ></div>
                            <!-- @if(spec.minitext) {
                                <p class="minitext">{{spec.minitext}} </p>
                            } -->
                        </div>
                    </td>
                </tr>
            }
        </table>
    }
</div>